import gsap from "gsap"

export default class Alert {
	constructor(element, options = {}) {
		this.element = element
		this.options = {
			autoHideDelay: 3,
			removeOnHide: false,
			onHide: null,
			...options
		}
		this.visible = false
		this.hideCall = null
		this.setTl()
		this.events()
		this.show()
		this.scheduleHide()
	}
	
	events() {
		this.element.addEventListener("click", () => this.hide())
	}

	scheduleHide() {
		if (!Number.isFinite(this.options.autoHideDelay) || this.options.autoHideDelay <= 0) return
		if (this.hideCall) this.hideCall.kill()
		this.hideCall = gsap.delayedCall(this.options.autoHideDelay, () => this.hide())
	}
	
	setTl() {
		this.tl = new gsap.timeline({
			paused: true,
			onReverseComplete: () => this.onHidden()
		}).from(this.element, {
			ease: "back.out(.7)",
			opacity: 0,
			display: "none",
			y: -60
		}, 0)
	}
	
	show() {
		if (this.visible) return false
		this.visible = true
		this.scheduleHide()
		return this.tl.duration(.9).play()
	}
	
	hide() {
		if (!this.visible) return false
		this.visible = false
		if (this.hideCall) {
			this.hideCall.kill()
			this.hideCall = null
		}
		return this.tl.duration(.45).reverse()
	}

	onHidden() {
		if (this.options.removeOnHide) {
			this.element.remove()
		}

		if (typeof this.options.onHide === "function") {
			this.options.onHide(this)
		}
	}
}